import type { Brand } from '@openx/types/brand.ts';
import axios from 'axios';

import { fetchApiResponseHandler } from '../../../api/utils.ts';

export function fetchBrands(brandsId: string[]): Promise<Brand[]> {
  const params = new FormData();
  params.append('filter', JSON.stringify({ id: brandsId }));

  return fetchApiResponseHandler(axios.post(`/market/brands?size=${brandsId.length}`, params));
}

export function searchBrands(phrase: string, apiRequestLimit = 500): Promise<Brand[]> {
  const params = {
    order: 'asc',
    size: apiRequestLimit,
    sort: 'name.none',
    user_input: phrase,
  };

  return fetchApiResponseHandler(axios.post('/market/brands', null, { params }));
}
